import { render, staticRenderFns } from "./indexSetPwdWindow.vue?vue&type=template&id=28c8b422&scoped=true&"
import script from "./indexSetPwdWindow.vue?vue&type=script&lang=js&"
export * from "./indexSetPwdWindow.vue?vue&type=script&lang=js&"
import style0 from "./indexSetPwdWindow.vue?vue&type=style&index=0&id=28c8b422&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8b422",
  null
  
)

export default component.exports